import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const TypeType2SocketIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 24 24" fill="none" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.462 20.961a12.14 12.14 0 0 0 5.463 1.539H12a12.13 12.13 0 0 0 9.705-5.392c4.297-6.36.892-11.73.435-12.398-1.436-3.123-5.971-2.94-6.501-2.92l-.047.002H8.407c-.225-.014-5.085.008-6.54 2.91-.427.623-3.892 6.008.428 12.406a12.14 12.14 0 0 0 4.167 3.853Zm7.551-12.708a1.628 1.628 0 1 0 1.809-2.707 1.628 1.628 0 0 0-1.809 2.707Zm-5.919.004a1.628 1.628 0 1 0 1.798-2.714 1.628 1.628 0 0 0-1.798 2.714Zm-2.357 5.528a2.438 2.438 0 1 1 2.438-2.437 2.445 2.445 0 0 1-2.438 2.437Zm4.571-.41c.401.267.873.41 1.355.41a2.445 2.445 0 0 0 2.437-2.437 2.438 2.438 0 1 0-3.792 2.026Zm7.28.41a2.438 2.438 0 1 1 2.437-2.437 2.445 2.445 0 0 1-2.438 2.437ZM7.345 18.707a2.438 2.438 0 1 0 2.709-4.054 2.438 2.438 0 0 0-2.709 4.054Zm7.279.41a2.438 2.438 0 1 1 2.438-2.437 2.445 2.445 0 0 1-2.438 2.438Z"
            fill="currentColor"
        />
    </Svg>
);
